const msToReadableTime = (duration: number) => {
  let seconds = Math.floor((duration / 1000) % 60).toString();
  const minutes = Math.floor((duration / (1000 * 60)) % 60).toString(),
    hours = Math.floor((duration / (1000 * 60 * 60)) % 24).toString();

  seconds = Number(seconds) < 10 ? '0' + seconds : seconds;

  return `${Number(hours) > 0 ? `${hours}:` : ''}${minutes}:${seconds}`;
};

export default msToReadableTime;
